export default __webpack_public_path__ + "static/media/804.922fb1d2.png";